import DOMPurify from "dompurify";

/**
 * Sanitize HTML before injecting via `dangerouslySetInnerHTML`.
 *
 * Used for email body rendering (Zoho ticket content) and WATI thread
 * previews — both can contain user-generated HTML that must NOT be allowed
 * to execute scripts or steal auth tokens from localStorage.
 *
 * We allow the standard email-safe tag set (including basic styling and
 * tables) but drop `<script>`, event handlers, and `javascript:` URLs.
 */
const EMAIL_CONFIG = {
  ALLOWED_TAGS: [
    "a", "b", "i", "em", "strong", "u", "s", "strike", "sub", "sup",
    "p", "br", "hr", "div", "span", "pre", "code", "blockquote",
    "ul", "ol", "li",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "table", "thead", "tbody", "tfoot", "tr", "th", "td",
    "img", "figure", "figcaption",
    "font", "center", "small", "big",
  ],
  ALLOWED_ATTR: [
    "href", "target", "rel", "title", "alt", "src", "width", "height",
    "style", "class", "align", "valign", "colspan", "rowspan",
    "border", "cellpadding", "cellspacing", "color", "face", "size",
    "bgcolor",
  ],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input", "link", "meta"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus", "onblur", "formaction"],
};

export function sanitizeHtml(dirty, options = {}) {
  if (dirty == null) return "";
  if (typeof dirty !== "string") dirty = String(dirty);
  return DOMPurify.sanitize(dirty, { ...EMAIL_CONFIG, ...options });
}

// Force any rendered <a> to open in a new tab and drop opener reference.
// This is applied once globally; idempotent.
if (typeof window !== "undefined" && !window.__DOMPURIFY_HOOK_ADDED__) {
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
  window.__DOMPURIFY_HOOK_ADDED__ = true;
}
